import type { ECountry } from '@/shared/enum/country.enum'
import { mceProductionUrls, mceStageUrls } from '@/shared/constants/mce-url.constant'
import isStageEnviroment from '@/shared/utils/is-stage-enviroment'

const getMceUrlByCountry = (country: ECountry): string | undefined => {
  const mceUrls = isStageEnviroment() ? mceStageUrls : mceProductionUrls

  return mceUrls.get(country)
}

export default getMceUrlByCountry
